import { LockKeyhole } from 'lucide-react';
import { useSession } from '../state/session.ts';
import styles from './ReadOnlyNote.module.css';

/**
 * Stands where an action the person's role doesn't allow would be: what they can't do and whom to
 * ask. One per page; visible text in reading order, never a disabled button with a tooltip.
 */
export function ReadOnlyNote({ children }: { children: string }) {
  const org = useSession((s) => s.workspace?.organization?.name);
  return (
    <p className={styles.note} role="note">
      <LockKeyhole size={16} aria-hidden="true" />
      <span>
        {children} {org ? `Ask an admin of ${org}.` : 'Ask a workspace owner or admin.'}
      </span>
    </p>
  );
}
